import { render, staticRenderFns } from "./POIStateLegend.vue?vue&type=template&id=2432049c"
import script from "./POIStateLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./POIStateLegend.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports